import { Fragment } from 'react';
import { Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { IProduct } from '../products';
import SendGiftForm from './SendGiftForm';

export interface SendGiftModalProps {
    modalOpen?: boolean,
    toggleModal: () => void,
    selectedProduct?: IProduct
}

export default function SendGiftModal(props: SendGiftModalProps) {

    const modalOpen = props.modalOpen
    const toggleModal = props.toggleModal
    const selectedProduct = props.selectedProduct

    return(<Modal isOpen={modalOpen} toggle={toggleModal} size='lg'>
    {selectedProduct ?
        <Fragment>
            <ModalHeader toggle={toggleModal}>
                {selectedProduct.name}
            </ModalHeader>
            <ModalBody>
                <div className='product-modal-row'>
                    <Col>
                        <Row>
                            <strong>Regalo:</strong>
                        </Row>
                        <Row className='h-25'>
                            <Col className="my-auto text-center justify-content-center"><div className="img-wrapper" style={{ backgroundImage: `url("./img/${selectedProduct.img}")` }} /></Col>
                            <Col className="my-auto text-center">{selectedProduct.name}</Col>
                            <Col className="my-auto text-center"><div className="price">$ {selectedProduct.price.toLocaleString()}</div></Col>
                        </Row>
                    </Col>
                </div>
                <div className='product-modal-row'>
                    <Col>
                        <Row>
                            <strong>Datos de la cuenta:</strong>
                        </Row>
                        <Row className='justify-content-center cbu'>
                            Banco Santander
                        </Row>
                        <Row className='justify-content-center cbu'>
                            Titular: Marcos Tarasido
                        </Row>
                        <Row className='justify-content-center cbu'>
                            Número de cuenta: 558-404256/3
                        </Row>
                        <Row className='justify-content-center cbu'>
                            CBU: 0720558388000040425636
                        </Row>
                        <Row className='justify-content-center cbu'>
                            Alias: marcos.clari
                        </Row>
                    </Col>
                </div>
                <div className='product-modal-row'>
                    <Col>
                        <Row>
                            <strong>Datos de las personas que regalan:</strong>
                        </Row>
                        <Row className='m-2'>
                            <SendGiftForm selectedProduct={selectedProduct} toggleModal={toggleModal} />
                        </Row>
                    </Col>
                </div>
            </ModalBody>
        </Fragment>
        : <Fragment />}

</Modal>)
}